import { DisplayInfo } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import { TranslationsKeys } from '../../../../../../locales/translations';

function AcademicOfferScheduleEmpty() {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_ACADEMIC_OFFERS,
  );
  return (
    <Row className="py-5">
      <Col xs={12} className="d-flex justify-content-center align-items-center">
        <DisplayInfo
          title={t('schedule.empty.title')}
          textBody={t('schedule.empty.body')}
        />
      </Col>
    </Row>
  );
}
export { AcademicOfferScheduleEmpty };
